// const API_BASE_URL = "http://localhost/matrimony";
// const API_BASE_URL_IMAGE = "http://127.0.0.1/matrimony/";

const API_BASE_URL = "https://matrimony.gudstart.com/api";
const API_BASE_URL_IMAGE = "https://matrimony.gudstart.com/api/";
const apiEndpoints = {
  register: `${API_BASE_URL}/register.php`,
  checkUser: `${API_BASE_URL}/check_user.php`,
  getOptions: `${API_BASE_URL}/get_options.php`,
  getProfile: `${API_BASE_URL}/getProfile.php`,
  membership: `${API_BASE_URL}/membership.php`,
  login: `${API_BASE_URL}/login.php`,
  image: `${API_BASE_URL_IMAGE}`,
  sendEnquiry: `${API_BASE_URL}/send_enquiry.php`,
  checkEnquiryStatus: `${API_BASE_URL}/check_enquiry_status.php`,
  getRequestedEnquiries: `${API_BASE_URL}/get_requested_enquiries.php`,
  getEnquiryCount: `${API_BASE_URL}/get_enquiry_count.php`,
  toggleWishlist: `${API_BASE_URL}/toggle_wishlist.php`,
  getWishlist: `${API_BASE_URL}/get_wishlist.php`,
  subscriptionPlans: `${API_BASE_URL}/subscription_plans.php`,
  payments: `${API_BASE_URL}/payments_api.php`,
  assignPackage: `${API_BASE_URL}/payments_api.php`,
  createEnquiry: `${API_BASE_URL}/enquiry_create.php`,
  getUserPlan: `${API_BASE_URL}/get_user_plan.php`,
};

export default apiEndpoints;
